import { ItemList } from '../../orm'

class AdminCustomerOutgoingFaxSettingsList extends ItemList {
    getEntityKey() {
        return "admin/customer_outgoing_fax_settings"
    }
}

export const adminCustomerOutgoingFaxSettingsList = new AdminCustomerOutgoingFaxSettingsList("admin_customer_outgoing_fax_settings__default")
